import { useEffect, useState } from 'react';

/**
 * Whether the screen is phone-sized.
 *
 * Most of the app decides this in CSS, and for hiding a column that is the right
 * tool. A phone-sized stock row is not a narrower table row though — it is a card
 * carrying its own buttons — and rendering both trees would double the list and
 * duplicate every test id in it. So this one asks the browser directly.
 *
 * The breakpoint is Tailwind's `lg`, which is already where Screen stops pinning
 * panes to the viewport and lets the page take one scroll.
 */
const MOBILE_QUERY = '(max-width: 1023px)';

const read = (query) => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(query).matches;
};

export function useIsMobile(query = MOBILE_QUERY) {
  const [matches, setMatches] = useState(() => read(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches);
    // addListener is the deprecated spelling, and the only one older WebKit has
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
}

export default useIsMobile;
